<template>
  <div class="modal fade createNewModal" id="AddModalCategProduit" tabindex="-1" ref="addCategProduitModalRef"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="categProduitForm" @submit="addcategProduit" :validation-schema="categProduitSchema">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrez le code" />
                  <ErrorMessage name="code" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom <span class="text-danger">*</span>
                  </label>
                  <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrez le nom" />
                  <ErrorMessage name="name" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description <span class="text-danger">*</span>
                  </label>
                  <Field name="description" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrez le nom" />
                  <ErrorMessage name="description" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Niveau de risque <span class="text-danger">*</span>
                  </label>
                  <Field name="risk_level" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrez le risque" />
                  <ErrorMessage name="risk_level" class="text-danger" />
                </div>
              </div>
             
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
          @click="resetValue()"></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { CategorieProduit } from '@/models/CategorieProduit';

export default defineComponent({
  name: "AddModalCategProduit",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }) {
    const categProduitSchema = Yup.object().shape({
      code: Yup.string().required('Le code est obligatoire'),
      name: Yup.string().required("Le nom est obligatoire"),
      description: Yup.string().required("La description est obligatoire"),
      risk_level: Yup.string().required("Le niveau de risque est obligatoiree")

    });

    const categProduitForm = ref<CategorieProduit | null>(null);
    const addCategProduitModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter une catégorie");
    const btntext = ref('Ajouter');
  

    watch(() => props.item, (newValue) => {
      getCategorieProduit(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
        title.value = "Modifier une catégorie de Produit";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter une catégorie de Produit";
        btntext.value = "Ajouter";
      }
    }

   

    const getCategorieProduit = async (id: number) => {
      return ApiService.get("/categProduit/" + id)
        .then(({ data }) => {
          const donnees = data.data;
          for (const key in donnees) {
            categProduitForm.value?.setFieldValue(key,
              (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
            );
          }
          emit('openmodal', addCategProduitModalRef.value);

        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const addcategProduit = async (values: any, categProduitForm) => {
      values = values as CategorieProduit;

      if (isUPDATE.value) {
        ApiService.put("/categProduit/" + values.id, values)
          .then(({ data }) => {
            if (data.code == 200) {
              success(data.message);
              categProduitForm.resetForm();
              hideModal(addCategProduitModalRef.value);
              isUPDATE.value = false;
              btnTitle();
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        ApiService.post("/categProduit", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message);
              categProduitForm.resetForm();
              hideModal(addCategProduitModalRef.value);
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      }
    };
  
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isUPDATE.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };



    return {
      categProduitSchema,
      addCategProduitModalRef,
      addcategProduit,
      categProduitForm,
      title, btntext, resetValue,
    };
  },
});
</script>